// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ThreeColumnsSvg from '@rsuite/icon-font/lib/layout/ThreeColumns';
var ThreeColumns = createSvgIcon({
  as: ThreeColumnsSvg,
  ariaLabel: 'three columns',
  category: 'layout',
  displayName: 'ThreeColumns'
});
export default ThreeColumns;